import { FormikProps } from "formik";
import { ICustomInputProps } from "../form/ICTextInput";
import { ICTextInput } from "../form/index";
import { cn } from "../../lib";
interface ICustomFormikTextInput<T> extends FormikProps<T>, ICustomInputProps {
  fieldName: keyof T;
  placeholder: string;
  containerClassName?: string;
  onChangeText?: (text: string) => void;
}
const ICFormikTextInput = <T extends Object>(
  props: ICustomFormikTextInput<T>
) => {
  const {
    handleChange,
    handleBlur,
    touched,
    errors,
    values,
    fieldName,
    placeholder,
    containerClassName,
    onChangeText,
    ...IDFTextInputProps
  } = props;
  const fieldNameStr = props.fieldName as string;

  return (
    <div className={cn({ [`${containerClassName}`]: containerClassName })}>
      <ICTextInput
        type="text"
        {...IDFTextInputProps}
        name={fieldNameStr}
        id={fieldNameStr}
        label={placeholder}
        onChange={(event) =>
          onChangeText ? onChangeText(event.target.value) : handleChange(event)
        }
        onBlur={handleBlur}
        errorMessage={
          touched[fieldName] && errors[fieldName] ? errors[fieldName] : ""
        }
        value={values[fieldName] as string}
      />
    </div>
  );
};
export default ICFormikTextInput;
